module.exports = __webpack_public_path__ + "media/images/version_merge/steps_fill_application-89786b5723c034cc6a890d685b730cc6.jpg";